<!-- Cabecera -->
<app-header-area-cliente></app-header-area-cliente>

<!-- Contenido -->
<router-outlet></router-outlet>